module.exports = __webpack_public_path__ + "img/blog-nooreash.6ccdff1d.png";